<script setup lang="ts">
    import type { IWidgetProps } from '~/composables/widgets';
    import type { GoogleFormSnippet, GoogleFormWidgetData } from '~/@types/cms';

    const props = defineProps<IWidgetProps<GoogleFormWidgetData>>();

    const { colorMapper } = useStyle();

    // TODO rework if google forms need rework after loyalty tickets
    const googleFormData = computed<GoogleFormSnippet>(() => {
        return {
            formId: props.data.form,
            successMessage: props.data.success,
        };
    });

    const background = computed(() => colorMapper[props.data.background || 'grey']);
</script>
<template>
    <div :class="background">
        <lazy-mol-intro
            v-if="data.intro"
            :title="data.intro.title"
            :description="data.intro.subtitle" />
        <atm-grid class="py-8 md:py-10">
            <div :class="['col-span-2', data.fullWidth ? 'md:col-span-12' : 'md:col-start-3 md:col-end-11']">
                <lazy-org-google-form-widget
                    v-if="data"
                    :google-form="googleFormData"
                    :selected-product-id="data.selectedProductId"
                    :background="background" />
            </div>
        </atm-grid>
    </div>
</template>
